import { createApp } from 'vue';
import Sticky from 'utils/sticky-directive';
import CommonPlugin from 'plugins/common-plugin';
import store from 'stores/product-search';
import ProductSearch from 'views/ProductSearch.vue';
import { i18n } from 'utils/i18n';

const app = createApp({
  el: '#app',
  components: { ProductSearch }
});

app.use(CommonPlugin);
app.use(store);
app.use(i18n);
app.use(Sticky);

require('styles/pages/product-search.less');

app.mount('#app');
